import { FormSelectOption } from '@/modules/core/form/models/FormSelectOption';
import SmartCampaignFormService from '@/modules/ta/smartcampaign/services/SmartCampaignFormService';
import { SmartCampaignConstants } from '@/modules/ta/smartcampaign/smartcampaign.constants';

export class SmartCampaignSelectOption extends FormSelectOption {
  constructor(config = {}) {
    super({
      placeholder: i18n.$t('Select a SmartCampaign'),
      ...config,
    });
  }

  getSmartCampaignData(searchParams) {
    if (searchParams.q) {
      searchParams.q = `${searchParams.q}`;
    }
    const params = { ...searchParams };
    params[SmartCampaignConstants.CAMPAIGN_TYPE] = SmartCampaignConstants.TYPE.FILTERING;
    return SmartCampaignFormService.getValues({
      fields: 'id',
      ...params,
    });
  }

  /**
   * @param params
   * @returns {Promise<*>}
   */
  getData(searchParams = {}) {
    return this.getSmartCampaignData(searchParams);
  }
}
